import React from 'react';
import { Typography, Stack } from '@mui/material';
import { Box, styled } from '@mui/system';
import { connect } from 'react-redux';

import AuthButton from '../../components/authSubmitButton';
import { logoutAction } from '../../store/actions';
import { history } from '../../../../store/store';
import { VerifyBadge } from '../../../../shared/components/icons';

const MarginBox = styled(Box)(() => ({
  marginTop: '2rem',
}));

const SpreadBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  height: '100%',
  position: 'relative'
}));

interface IAccountApproval {
  logout: () => void;
  rejected?: boolean;
  inactive?: boolean;
}

function AccountApproval(accountApprovalProps: IAccountApproval) {
  const { logout, rejected = false, inactive = false} = accountApprovalProps;

  const logoutAndRedirect = () => {
    logout();
    history.push('/auth');
  };

  const safeText = 'To keep Clara safe and authentic, we manually review every profile. You will receive access within 24 hours. Thanks for your patience!';
  return (
    <SpreadBox>
      <Stack alignItems='center' direction='column'>
        <MarginBox style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
        }}>
          <VerifyBadge />
          <Typography style={{
            marginTop:'48px'
          }} variant='h4' fontWeight="bold" textAlign="center">
            Your profile is {rejected ? ' rejected!' : inactive ? "deactivated!" : ' being reviewed!'}
          </Typography>
          <Typography
            sx={{ mt: '24px', color: 'claraPalette.gray1' }}
            variant='body1'
            display='inline-block'
            textAlign="center"
            style={{
              color:'#828282'
            }}
          >
            {rejected || inactive ? '' : safeText}
          </Typography>
        </MarginBox>
      </Stack>
      <AuthButton variant="contained" onClick={logoutAndRedirect}
        sx={{
          position: 'absolute',
          bottom: '0'
        }}
      >
        Logout
      </AuthButton>
    </SpreadBox>
  );
}

export default connect(null, {
  logout: logoutAction
})(AccountApproval);